import React from 'react';
import {AlertProps, Portal, Snackbar} from '@mui/material';
import {Alert} from '@mui/lab';

type PortalledSnackbarProps = {
    message: string
    onClose: () => void
    alertProps?: AlertProps
}

const PortalledSnackbar: React.FC<PortalledSnackbarProps> = ({message, onClose, ...alertProps}) => {

    return <Portal container={document.body}>

        <Snackbar
                anchorOrigin={{horizontal: "left", vertical: "bottom"}}
                open={Boolean(message)}
                autoHideDuration={2000}
                onClose={onClose}
        >
            <Alert
                    onClose={onClose}
                    severity="info"
                    sx={{width: '100%'}}
                    {...alertProps}
            >
                {message}
            </Alert>
        </Snackbar>

    </Portal>
};

export default PortalledSnackbar;
